import { render, staticRenderFns } from "./importorderproduct.vue?vue&type=template&id=5ebc89a9"
import script from "./importorderproduct.vue?vue&type=script&lang=js"
export * from "./importorderproduct.vue?vue&type=script&lang=js"
import style0 from "./importorderproduct.vue?vue&type=style&index=0&id=5ebc89a9&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports